import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Open_Sans%22,%22arguments%22:[{%22weight%22:[%22400%22,%22600%22,%22700%22,%22800%22],%22subsets%22:[%22latin%22],%22display%22:%22swap%22}],%22variableName%22:%22openSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Open Sans', 'Open Sans Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
